import { CampaignIO, IOStatus } from 'shared/src/api/io-types';

const STATUS_ORDER: Record<IOStatus, number> = {
  no_doc: 0,
  created: 1,
  recalled: 2,
  declined: 3,
  expired: 4,
  out_for_signature: 5,
  completed: 6
};

export function sortIOsByStatus(ios: CampaignIO[]): CampaignIO[] {
  return [...ios].sort((a, b) => STATUS_ORDER[a.status] - STATUS_ORDER[b.status]);
}
